import { useEffect } from 'react';
import { useConsent } from '@buzzfeed/react-components';
import { CLUSTER } from '../../constants';
import { useProfileUserLayer } from './useUserLayers';

export function useNavTracking(trackingData = {}) {
  useConsent('tracking');
  const profileUserLayer = useProfileUserLayer();
  const commonProfileUserLayer = {
    ...profileUserLayer(),
    ...trackingData
  };

  useEffect(() => {
    window.clientEventTracking = {
      getPageContextLayer: () => {
        return () => commonProfileUserLayer;
      },
      env: CLUSTER
    };
  }, [commonProfileUserLayer]);

  return () => window.clientEventTracking;
}
